export default __webpack_public_path__ + "static/media/Appraisee.64b0f0cc.png";